import { render, staticRenderFns } from "./last_commit.vue?vue&type=template&id=03b78546&vue3"
import script from "./last_commit.vue?vue&type=script&lang=js&vue3"
export * from "./last_commit.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports